import { render, staticRenderFns } from "./TestContent.vue?vue&type=template&id=852e3790&scoped=true"
import script from "./TestContent.vue?vue&type=script&lang=js"
export * from "./TestContent.vue?vue&type=script&lang=js"
import style0 from "./TestContent.vue?vue&type=style&index=0&id=852e3790&prod&lang=scss&scoped=true"
import style1 from "./TestContent.vue?vue&type=style&index=1&id=852e3790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852e3790",
  null
  
)

export default component.exports